import React from "react";
import logo from "./images/bitcoin-live/logo.png";
import { HomepageGlobalStyles } from "./views/Homepage/styles";
import {
  ErrorBoundaryAction,
  ErrorBoundaryBrand,
  ErrorBoundaryBrandAccent,
  ErrorBoundaryBrandText,
  ErrorBoundaryCard,
  ErrorBoundaryCopy,
  ErrorBoundaryEyebrow,
  ErrorBoundaryGlow,
  ErrorBoundaryHint,
  ErrorBoundaryLogo,
  ErrorBoundaryPage,
  ErrorBoundaryTitle,
} from "./Errorboundary.styles";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    this.setState({
      hasError: true,
    });
  }

  handleCache = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    localStorage.clear();
    window.location.href = "/login";
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryPage>
          <HomepageGlobalStyles />
          <ErrorBoundaryGlow aria-hidden="true" />
          <ErrorBoundaryCard>
            <ErrorBoundaryBrand>
              <ErrorBoundaryLogo src={logo} alt="" />
              <ErrorBoundaryBrandText>
                bitcoin
                <ErrorBoundaryBrandAccent>.live</ErrorBoundaryBrandAccent>
              </ErrorBoundaryBrandText>
            </ErrorBoundaryBrand>
            <ErrorBoundaryEyebrow>Something went wrong</ErrorBoundaryEyebrow>
            <ErrorBoundaryTitle>Loading failed</ErrorBoundaryTitle>
            <ErrorBoundaryCopy>
              This screen could not finish loading. Reload to clear the local
              session and try again.
            </ErrorBoundaryCopy>
            <ErrorBoundaryAction type="button" onClick={this.handleCache}>
              Click here to reload
            </ErrorBoundaryAction>
            <ErrorBoundaryHint>or write us in support.</ErrorBoundaryHint>
          </ErrorBoundaryCard>
        </ErrorBoundaryPage>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
